import React from 'react';
import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * SortableTh — cabeçalho <th> clicável com ícone de ordenação.
 * Uso:
 *   <SortableTh sortKey="data" activeKey={sortKey} dir={sortDir} onToggle={toggleSort}>Data</SortableTh>
 */
export function SortableTh({
  children,
  sortKey,
  activeKey,
  dir,
  onToggle,
  align = 'left',
  className,
}) {
  const isActive = activeKey === sortKey;
  const alignClass =
    align === 'right' ? 'text-right justify-end'
    : align === 'center' ? 'text-center justify-center'
    : 'text-left justify-start';

  return (
    <th className={cn('py-2 px-3 font-semibold select-none', className)}>
      <button
        type="button"
        onClick={() => onToggle(sortKey)}
        className={cn(
          'w-full flex items-center gap-1 hover:text-stone-800 transition',
          alignClass,
          isActive ? 'text-stone-800' : 'text-stone-500'
        )}
        aria-label={`Ordenar por ${typeof children === 'string' ? children : sortKey}`}
      >
        <span>{children}</span>
        {isActive ? (
          dir === 'asc'
            ? <ChevronUp className="h-3.5 w-3.5" />
            : <ChevronDown className="h-3.5 w-3.5" />
        ) : (
          <ChevronsUpDown className="h-3.5 w-3.5 opacity-40" />
        )}
      </button>
    </th>
  );
}

export default SortableTh;
